
import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

interface FormData {
  name: string;
  email: string;
  password: string;
}

export const useTempUserData = (initialFormData: FormData) => {
  const [formData, setFormData] = useState<FormData>(initialFormData);

  useEffect(() => {
    const tempUserEmail = localStorage.getItem('tempUserEmail');
    
    if (tempUserEmail) {
      // Fetch user details from temp_users table
      const fetchTempUser = async () => {
        const { data, error } = await supabase
          .from('temp_users')
          .select('name, email, industry')
          .eq('email', tempUserEmail)
          .single();
          
        if (data && !error) {
          setFormData(prevData => ({
            ...prevData,
            name: data.name || '',
            email: data.email || ''
          }));
        } else {
          // If we couldn't find in database, check if stored messages contain the email
          const storedMessages = localStorage.getItem('generatedMessages');
          if (storedMessages) {
            setFormData(prevData => ({
              ...prevData,
              email: tempUserEmail
            }));
          }
        }
      };
      
      fetchTempUser();
    }
  }, []);

  return { formData, setFormData };
};
